import { useState } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "Qu'est-ce que le convoyage de véhicule ?",
    a: "Le convoyage consiste à faire déplacer votre véhicule d'un point A à un point B par un chauffeur professionnel. Idéal après un achat entre particuliers, un déménagement, ou pour livrer un véhicule à un client.",
  },
  {
    q: "Mon véhicule est-il assuré pendant le convoyage ?",
    a: "Oui, votre véhicule est intégralement couvert par notre assurance professionnelle tous risques du départ à la livraison. Aucune franchise n'est à votre charge en cas de sinistre.",
  },
  {
    q: "Puis-je faire convoyer un véhicule non-roulant ?",
    a: "Absolument. Nous disposons de camions-plateaux pour les véhicules non-roulants (accidentés, en panne, sans batterie). Précisez-le simplement lors de votre demande de devis.",
  },
  {
    q: "Comment est calculé le prix ?",
    a: "Nous appliquons un tarif dégressif au kilomètre : 1,30 €/km entre 0 et 100 km, 1,10 €/km entre 101 et 300 km, et 1,00 €/km au-delà de 300 km. Le prix s'affiche en temps réel lors du devis.",
  },
  {
    q: "Quel acompte est demandé à la réservation ?",
    a: "Pour un convoyage : 30% d'acompte à la réservation, solde avant ou à la livraison. Pour un trajet VTC ponctuel : 100% à la réservation. Pour une mise à disposition VTC : 30% d'acompte, solde à la fin de la prestation.",
  },
  {
    q: "Que se passe-t-il si vous refusez ma réservation ?",
    a: "Si nous ne pouvons pas donner suite à votre demande, le remboursement intégral est déclenché automatiquement via Stripe. Selon votre banque, les fonds réapparaissent sous 3 à 10 jours ouvrés.",
  },
  {
    q: "Quels sont les moyens de paiement acceptés ?",
    a: "Nous acceptons les cartes bancaires (Visa, Mastercard, Amex) via notre passerelle sécurisée Stripe. Aucune donnée bancaire n'est stockée sur nos serveurs.",
  },
  {
    q: "Comment suivre ma réservation ?",
    a: "Chaque réservation reçoit une référence unique au format DSA-XXXXXX. Vous pouvez la saisir sur notre page Suivi à tout moment pour consulter l'avancement, télécharger votre devis, et — après confirmation — votre facture.",
  },
  {
    q: "Le service VTC est-il disponible la nuit et les jours fériés ?",
    a: "Oui, 7 jours sur 7. Une majoration de 20% s'applique le dimanche et les jours fériés, et une majoration de nuit s'ajoute pour les prises en charge entre 22h et 6h.",
  },
  {
    q: "Où intervenez-vous ?",
    a: "Sur toute la France métropolitaine : Paris, Lyon, Marseille, Toulouse, Bordeaux, Nantes, Lille, Strasbourg, Nice, Rennes et toutes les villes intermédiaires. Zones DOM et frontalières sur devis.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(null);
  return (
    <div className="min-h-screen bg-[#050505]" data-testid="faq-page">
      <SEO
        title="Questions fréquentes"
        description="Réponses aux questions les plus fréquentes sur les services de convoyage et VTC de DAS SIMAO AUTO — tarifs, assurance, paiement, remboursement."
      />
      <Header />
      <section className="pt-32 pb-20 max-w-3xl mx-auto px-6 lg:px-10">
        <div className="text-xs tracking-[0.5em] gold uppercase">FAQ</div>
        <h1 className="mt-3 font-serif text-white text-5xl leading-tight">Questions fréquentes</h1>
        <p className="mt-4 text-gray-400">
          Tout ce qu'il faut savoir avant de réserver. Une autre question ? Écrivez-nous.
        </p>

        <div className="mt-12 divide-y divide-white/5 border-t border-white/5">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="py-2">
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  data-testid={`faq-question-${i}`}
                  aria-expanded={isOpen}
                  className="w-full py-4 flex items-center justify-between text-left group focus:outline-none"
                >
                  <span className="font-serif text-lg text-white group-hover:gold transition-colors">
                    {f.q}
                  </span>
                  <ChevronDown
                    size={20}
                    className={`gold shrink-0 ml-4 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
                  />
                </button>
                {isOpen && (
                  <div
                    data-testid={`faq-answer-${i}`}
                    className="pb-5 pr-8 text-gray-400 leading-relaxed"
                  >
                    {f.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </section>
      <Footer />
    </div>
  );
}
